import {
  initialState,
  Actions,
  State,
  EDIT_INVITATION,
  EDIT_INVITATION_SUCCESS,
  EDIT_INVITATION_ERROR,
  RESET_EDIT_INVITATION,
} from '../../types/invitation/edit'

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case EDIT_INVITATION:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      }
    case EDIT_INVITATION_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      }
    case EDIT_INVITATION_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: action.payload,
          success: false,
        },
      }
    case RESET_EDIT_INVITATION:
      return {
        ...state,
        ...initialState,
      }
    default:
      return state
  }
}

export default reducers
